import { render, staticRenderFns } from "./DevaluationsItem.vue?vue&type=template&id=3204572c&"
import script from "./DevaluationsItem.vue?vue&type=script&lang=js&"
export * from "./DevaluationsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports